


































import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import CompanyInfo from "@/components/CompanyInfo.vue";
import FooterPolicy from "@/components/FooterPolicy";
import LocaleSwitch from "@/components/LocaleSwitch";
import SiteLogo from "@/components/SiteLogo";
import AgeConfirm from "./components/AgeConfirm.vue";

export default defineComponent({
  name: "PageLanding",
  components: { AgeConfirm, CompanyInfo, LocaleSwitch, BaseButton, SiteLogo, FooterPolicy, BasePage },
});
